import * as adminPortalDomainVerification from 'content/widgets/admin-portal-domain-verification.props';
import * as adminPortalSsoConnection from 'content/widgets/admin-portal-sso-connection.props';
import * as apiKeys from 'content/widgets/api-keys.props';
import * as directorySync from 'content/widgets/directory-sync.props';
import * as organizationSwitcher from 'content/widgets/organization-switcher.props';
import * as pipes from 'content/widgets/pipes.props';
import * as theme from 'content/widgets/styling/theme.props';
import * as userManagement from 'content/widgets/user-management.props';
import * as userProfile from 'content/widgets/user-profile.props';
import * as userSecurity from 'content/widgets/user-security.props';
import * as userSessions from 'content/widgets/user-sessions.props';
import type { MDXRemoteProps } from 'next-mdx-remote';

export const mdxRemoteScope = {
  widgets: {
    adminPortalDomainVerification,
    adminPortalSsoConnection,
    apiKeys,
    directorySync,
    organizationSwitcher,
    pipes,
    userManagement,
    userProfile,
    userSecurity,
    userSessions,
    theme,
  },
} satisfies MDXRemoteProps['scope'];
